import * as React from "react";
import { Modal, ModalFooter, ModalHeader } from "reactstrap";
import { getValue } from "@utils/lodash";
import Lottie from "lottie-react";
import bin from "@lottie/bin.json";
import "./delete.scss";

interface IDeleteModalProps {
  isOpen: boolean;
  handleModal: () => void;
  handleSubmit: () => void;
  deleteValue: string;
}
const DeleteModal: React.FunctionComponent<IDeleteModalProps> = (props) => {
  return (
    <Modal
      isOpen={getValue(props, `isOpen`, "")}
      toggle={props.handleModal}
    >
      {/* <ModalHeader>
        <h5 className="header_text">Delete</h5>
      </ModalHeader> */}
      <section className="delete-popup-wrapper">
        <div className="delete-popup-wrapper__popup">
          <div style={{ justifyContent: "center", display: "flex" }}>
            <div style={{ width: "25%", height: "25%", alignSelf: "center" }}>
              <Lottie animationData={bin} loop={true} />
            </div>
          </div>
          <div className="delete-popup-wrapper__form-group form-group">
            <p className="mt-3 delete-popup-wrapper__desc_text">
              Are you sure, You want to delete{" "}
              <b style={{ color: "black" }}>
                {getValue(props, `deleteValue`, "")}
              </b>{" "}
              ?
            </p>
          </div>
        </div>
      </section>
      <ModalFooter>
        <div className="delete-popup-wrapper__cta-wrapper">
          <button
            onClick={props.handleModal}
            className="delete-popup-wrapper__cta-btn delete-popup-wrapper__cta-btn--secondary"
          >
            No
          </button>
          <button
            className="delete-popup-wrapper__cta-btn delete-popup-wrapper__cta-btn--primary"
            onClick={props.handleSubmit}
          >
            Yes
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteModal;
